module.exports = __webpack_public_path__ + "static/images/txcz_gamecurrency.f9730ac.png";